<template>
  <div class="box5">
    <pageTitle
      title="多维度锻炼产品思维<br/>短时间掌握实用技能"
      text="产品经理7大职场高阶能力<br/>多方位打造懂业务、懂策略、懂数据的产品人"
      titleColor="#191c47"
      titColor="#666666"
    />

    <div class="nav-box">
      <div
        class="nav"
        v-for="(item, index) in list"
        :key="index"
        :class="{ 'cur-nav': cur == index }"
        @click="changeCur(index)"
        ref="nav"
      >
        {{ item.project }}
      </div>
      <div class="seat"></div>
    </div>

    <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
      <swiper-slide
        class="swiperwrap"
        v-for="(item, index) in list"
        :key="index"
        :class="`item${index}`"
        ref="block"
      >
        <div class="content">
          <div class="open">
            查看全部
            <img src="../../../assets/coursePage/ai/box11/open.png" alt />
          </div>
          <div class="stage">{{ item.nav }}</div>
          <div class="tag">主要掌握</div>

          <div
            class="subject-block"
            v-for="(item1, index1) in item.text"
            :key="index1 + 'a'"
          >
            <div class="block-title">{{ item1 }}</div>
          </div>

          <div class="tag tag2">涉及工具</div>
          <div class="subject-block2 targe">
            <div
              class="demo item"
              v-for="(item2, index2) in item.demo"
              :key="index2 + 'a'"
            >
              <img
                :src="
                  require(`../../../assets/coursePage/pm/box5/${item2}.png`)
                "
                alt
              />
              <h4>{{ list[cur].demoName[index2] }}</h4>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <van-popup v-model="show" position="bottom" round>
      <div class="block">
        <div class="block-tops">
          <div class="title">{{ list[cur].nav }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="tag">主要掌握</div>

        <div class="target">
          <p v-for="(item1, index1) in list[cur].text" :key="index1 + 'a'">
            {{ item1 }}
          </p>
        </div>

        <div class="tag tag3">涉及工具</div>
        <div :class="`item${cur}`">
          <div class="subject-block2 targe">
            <div
              class="demo item"
              v-for="(item2, index2) in list[cur].demo"
              :key="index2 + 'a'"
            >
              <img
                :src="
                  require(`../../../assets/coursePage/pm/box5/${item2}.png`)
                "
                alt
                ref="img"
              />
              <h4 ref="text">
                {{ list[cur].demoName[index2] }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    swiper,
    pageTitle,
    swiperSlide,
  },

  data() {
    let that = this;
    return {
      list: [
        {
          project: "能力一",
          nav: "基础能力",
          demo: [7, 4, 16, 15, 13, 8, 14, 12],
          demoName: [
            "Axure",
            "Xmind",
            "Visio",
            "Process on",
            "腾讯文档",
            "Tapd",
            "PPT",
            "Excel",
          ],
          text: [
            "认识互联网产品经理，熟悉产品经理工作流程；",
            "了解产品经理常见文档、产品体验报告、能够输出BRD/MRD/PRD三大文档；",
            "掌握需求收集、需求分析、产品常用工具的使用、产品规划及产品前后台原型设计。",
          ],
        },

        {
          project: "能力二",
          nav: "商城项目能力",
          demo: [20, 1, 22, 5, 21, 14, 7, 4, 16, 15, 13, 12, 8],
          demoName: [
            "问卷星",
            "腾讯问卷",
            "全数据",
            "易观",
            "艾瑞",
            "PPT",
            "Axure",
            "Xmind",
            "Visio",
            "Process on",
            "腾讯文档",
            "Excel",
            "Tapd",
          ],
          text: [
            "立项说明、产品概述、竞品分析、产品架构、需求分析；",
            "掌握商品中心订单中心、商品类目属性及订单售后交易等产品设计，以及首页搜索和个性化推荐的产品设计。",
          ],
        },

        {
          project: "能力三",
          nav: "运营策略能力",
          demo: [23, 7, 4, 16, 15, 8, 13, 14, 12],
          demoName: [
            "百度统计",
            "Axure",
            "Xmind",
            "Visio",
            "Process on",
            "Tapd",
            "腾讯文档",
            "PPT",
            "Excel",
          ],
          text: [
            "常见的拉新方法及产品设计，拼团活动设计逻辑，转化的作用及营销活动设计， 优惠券的玩法及产品设计，用户留存及流失预警，用户活跃及内容社区，用户传播及产品变现策略。",
          ],
        },

        {
          project: "能力四",
          nav: "数据产品架构能力",
          demo: [7, 4, 16, 15, 13, 8, 14, 12],
          demoName: [
            "Axure",
            "Xmind",
            "Visio",
            "Process on",
            "腾讯文档",
            "Tapd",
            "PPT",
            "Excel",
          ],
          text: [
            "数据分析流程、数据采集与清洗、数据可视化设计、数据分析方法、数据采集、数据后台、数据看板、用户画像、数据决策等。",
          ],
        },

        {
          project: "能力五",
          nav: "B端后台能力",
          demo: [12, 3, 9, 23, 11, 10, 2],
          demoName: [
            "Excel",
            "SQL",
            "友盟统计",
            "百度统计",
            "Growing IO",
            "诸葛IO",
            "Google",
          ],
          text: [
            "B端产品介绍、后台基础参数设计，采购管理与入库，仓储管理与销售入库，财务系统，分销系统，客服系统，工单与质检系统，IaaS、PaaS、SaaS的产品区别，中台产品定义及特点，业务中台、数据中台、技术中台、算法中台解析。",
          ],
        },

        // {
        //   project: "能力六",
        //   nav: "行业解析能力",
        //   demo: [12, 5, 8, 7, 16, 17, 4, 15, 6, 21, 18, 19, 13, 14],
        //   demoName: [
        //     "Excel",
        //     "易观",
        //     "Tapd",
        //     "Axure",
        //     "Visio",
        //     "七麦数据",
        //     "Xmind",
        //     "Process on",
        //     "199IT",
        //     "艾瑞网",
        //     "36Kr",
        //     "It桔子",
        //     "腾讯文档",
        //     "PPT",
        //   ],
        //   text: [
        //     "在线教育产品平台分类、K12行业产品案例解析、互联网金融产品、网贷产品、金融科技产品、消费金融产品案例解析等。",
        //   ],
        // },

        {
          project: "能力六",
          nav: "综合项目能力",
          demo: [5, 21, 6, 19, 18, 17, 4, 7, 16, 15, 8, 14, 13, 12],
          demoName: [
            "易观",
            "艾瑞",
            "199IT",
            "IT桔子",
            "36Kr",
            "七麦数据",
            "Xmind",
            "Axure",
            "Visio",
            "Process on",
            "Tapd",
            "PPT",
            "腾讯文档",
            "Excel",
          ],
          text: [
            "项目立项、需求分析、需求验证、功能架构设计、业务流程规划、产品原型设计、产品需求说明、项目需求评审、生产开发、上线运营迭代、版本迭代、用户反馈分析、在线CRM系统、教务管理系统、BI数据分析系统、直播服务平台系统等。",
          ],
        },
      ],
      cur: 0,
      show: false,
      showBlock: false,
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box8",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("nav-box")[1].scrollLeft =
              this.realIndex * 75;
          },
          click(e) {
            console.log(e.target.className);
            if (that.$refs.block) {
              that.show = true;
            }
            if (
              e.target.className == "play" ||
              e.target.className == "play-btn"
            ) {
              that.showVideo = true;
              that.src = that.subject[that.cur].video;
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 1000, false);
      this.cur = index;
    },
    open() {
      this.showBlock = true;
    },
  },
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/pm/box5/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .van-popup {
    padding-bottom: 32px;
    max-height: calc(100% - 80px);
    box-sizing: border-box;
    .target {
      margin-bottom: 40px;
    }
  }
  .pop-title {
    position: sticky;
    top: 0px;
    display: flex;
    justify-content: space-between;

    width: 610px;
    background: #fff;
    box-sizing: border-box;
    z-index: 50;
    align-items: center;
    border-bottom: 1px solid #d3def0;
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }
  }

  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .nav-box {
    overflow-x: scroll;
    transition: all 0.2s;
    display: flex;
    display: flex;
    justify-content: space-between;
    padding: 48px 32px 48px 32px;
    position: relative;
    font-family: PingFangSC-Medium;
    font-size: 26px;
    font-weight: 400;
    color: #4e5969;
    color: #191c47;
    width: 100%;
    .nav {
      flex-shrink: 0;
      width: 138px;
      height: 68px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(95, 89, 255, 0.12);
      border-radius: 8px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 68px;
      text-align: center;
      margin-right: 20px;
    }
    .nav:nth-child(7) {
      margin-right: 32px;
    }
    .cur-nav {
      background: linear-gradient(227deg, #ba6eff 0%, #8883fe 100%);
      color: #ffffff;
      border-radius: 10px;
      color: #ffffff;
    }
    .seat {
      width: 32px;
      flex-shrink: 0;
    }
  }
  .swiperwrap {
    height: 740px;
  }
  .content {
    width: 686px;
    height: 686px;
    background: #ffffff;
    box-shadow: 4px 8px 24px 0px #f2eeff;
    border-radius: 20px;
    border: 1px solid #ffffff;
    margin: 0 auto;
    border-radius: 20px;
    overflow: hidden;
    border: 2px solid #ffffff;
    padding-left: 32px;
    box-sizing: border-box;
    .open {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 30px;
      width: 100%;
      height: 140px;
      // background: #fff;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 40%,
        #fff 100%
      );
      border-radius: 0px 0px 20px 20px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 36px;
      box-sizing: border-box;
      z-index: 40;

      img {
        margin-left: 8px;
        width: 32px;
        height: 32px;
      }
    }
  }

  .stage {
    width: 686px;
    height: 112px;
    margin-bottom: 16px;
    background: linear-gradient(
      180deg,
      #e9e7ff 0%,
      rgba(249, 249, 255, 0) 100%
    );

    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    line-height: 48px;
    padding: 40px 0 0 32px;
    box-sizing: border-box;
    margin-left: -32px;
  }

  .tag {
    width: 152px;
    height: 52px;
    background: #f0f0ff;
    color: #5f59ff;
    border-radius: 0px 32px 32px 24px;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;

    line-height: 52px;
    text-align: center;
    margin-bottom: 24px;
  }
  .tag2 {
    margin-top: 40px;
    margin-bottom: 34px;
  }

  .subject-block {
    .block-title {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-right: 32px;
    }

    p {
      position: relative;
      display: flex;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      line-height: 42px;
      letter-spacing: 0px;
      color: #485265;
      span {
        position: absolute;
        top: 15px;
        left: -20px;
        min-width: 9px;
        height: 9px;
        background-color: #ffad00;
        transform: rotate(45deg);
      }
    }

    .block-p {
      margin-left: 20px;
    }
  }

  .subject-block:last-child.block-title {
    margin-bottom: 50px;
  }
  .subject-block2 {
    display: flex;

    flex-wrap: wrap;
  }
  .targe {
    font-family: PingFang SC;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;

    p {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
    }
    display: flex;
    flex-wrap: wrap;

    align-content: flex-start;
    .item {
      flex-shrink: 0;
      position: relative;
      margin-right: 46px;
      margin-bottom: 32px;
      font-size: 22px;
      width: 88px;
      img {
        width: 88px;
        height: 88px;
      }
      h4 {
        width: max-content;
        text-align: center;
        position: relative;
        white-space: nowrap;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .item:nth-child(5n) {
      margin-right: 0;
    }
  }
  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 24px;
      width: 170px;
      height: 56px;
      background: #f0f0ff;
      color: #5f59ff;
      border-radius: 0px 32px 32px 24px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;

      line-height: 56px;
    }
    .tag2 {
      width: 220px;
    }
    .target {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      p.indent {
        display: inline-block;
        text-align: justify;
        text-indent: -32px;
        padding-left: 40px;
      }
      p.indent:nth-child(9) ~ p.indent {
        text-indent: -43px;
        padding-left: 43px;
      }
    }
  }
  .subject-block2 {
    img {
      width: 88px;
      height: 88px;
      background: #ffffff;
      border-radius: 12px;
      border: 2px solid #c2c0ff;
      box-sizing: border-box;
    }
    h4 {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }
  .tag3 {
    margin-bottom: 40px !important;
  }
  .item0 {
    .subject-block2 {
      .demo:nth-child(2),
      .demo:nth-child(4),
      .demo:nth-child(5),
      .demo:nth-child(7),
      .demo:nth-child(8) {
        img {
          border: none;
        }
      }
    }
  }
  .item1 {
    .subject-block2 {
      .demo:nth-child(3),
      .demo:nth-child(4),
      .demo:nth-child(5),
      .demo:nth-child(6),
      .demo:nth-child(8),
      .demo:nth-child(10),
      .demo:nth-child(11),
      .demo:nth-child(12) {
        img {
          border: none;
        }
      }
    }
  }
  .item2 {
    .subject-block2 {
      .demo:nth-child(3),
      .demo:nth-child(5),
      .demo:nth-child(7),
      .demo:nth-child(8),
      .demo:nth-child(9) {
        img {
          border: none;
        }
      }
    }
  }
  .item3 {
    .subject-block2 {
      .demo:nth-child(2),
      .demo:nth-child(4),
      .demo:nth-child(5),
      .demo:nth-child(7),
      .demo:nth-child(8) {
        img {
          border: none;
        }
      }
    }
  }
  .item4 {
    .subject-block2 {
      .demo:nth-child(1),
      .demo:nth-child(2),
      .demo:nth-child(3) {
        img {
          border: none;
        }
      }
    }
  }
  .item5 {
    .subject-block2 {
      .demo:nth-child(1),
      .demo:nth-child(2),
      .demo:nth-child(7),
      .demo:nth-child(8),
      .demo:nth-child(10),
      .demo:nth-child(11),
      .demo:nth-child(12),
      .demo:nth-child(13),
      .demo:nth-child(14) {
        img {
          border: none;
        }
      }
    }
  }
  .item6 {
    .subject-block2 {
      .demo:nth-child(1),
      .demo:nth-child(2),
      .demo:nth-child(4),
      .demo:nth-child(5),
      .demo:nth-child(7),
      .demo:nth-child(10),
      .demo:nth-child(12),
      .demo:nth-child(13),
      .demo:nth-child(14) {
        img {
          border: none;
        }
      }
    }
  }
}
</style>
